import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { PublicLayout } from './components/PublicLayout'
import { SeoMetadata } from './components/SeoMetadata'
import { RoleGate } from './components/RoleGate'
import { Dashboard } from './pages/Dashboard'
import { Queue } from './pages/Queue'
import { Team } from './pages/Team'
import { Benchmarks } from './pages/Benchmarks'
import { Reports } from './pages/Reports'
import { HistoryRecords } from './pages/HistoryRecords'
import { HistoryReportDetail } from './pages/HistoryReportDetail'
import { EmployeeRecords } from './pages/EmployeeRecords'
import { Integrations } from './pages/Integrations'
import { Settings } from './pages/Settings'
import { EmployeeDetail } from './pages/EmployeeDetail'
import { BenchmarkDetail } from './pages/BenchmarkDetail'
import { Login } from './pages/Login'
import { Signup } from './pages/Signup'
import { Onboarding } from './pages/Onboarding'
import { EmployeeJoin } from './pages/EmployeeJoin'
import { EmployeeWorkspace } from './pages/EmployeeWorkspace'
import { Join } from './pages/Join'
import { Home } from './pages/public/Home'
import { Product } from './pages/public/Product'
import { HowItWorks } from './pages/public/HowItWorks'
import { Teams } from './pages/public/Teams'
import { IntegrationsPublic } from './pages/public/IntegrationsPublic'
import { Security } from './pages/public/Security'
import { Pricing } from './pages/public/Pricing'
import { About } from './pages/public/About'
import { Privacy } from './pages/public/Privacy'
import { Terms } from './pages/public/Terms'
import { Contact } from './pages/public/Contact'

export default function App() {
  return <>
    <SeoMetadata />
    <Routes>
    <Route element={<PublicLayout />}>
      <Route path="/" element={<Home />} />
      <Route path="/product" element={<Product />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/teams" element={<Teams />} />
      <Route path="/integrations" element={<IntegrationsPublic />} />
      <Route path="/security" element={<Security />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
    </Route>

    <Route path="/login" element={<Login />} />
    <Route path="/signup" element={<Signup />} />
    <Route path="/join" element={<Join />} />
    <Route path="/onboarding" element={<Onboarding />} />
    <Route path="/employee/join" element={<EmployeeJoin />} />
    <Route path="/employee" element={<RoleGate audience="employee"><EmployeeWorkspace /></RoleGate>} />

    <Route element={<RoleGate audience="manager"><AppShell /></RoleGate>}>
      <Route path="/app" element={<Dashboard />} />
      <Route path="/app/queue" element={<Queue />} />
      <Route path="/app/team" element={<Team />} />
      <Route path="/app/team/:id" element={<EmployeeDetail />} />
      <Route path="/app/team/:id/records/:view" element={<EmployeeRecords />} />
      <Route path="/app/sla-performance" element={<Benchmarks />} />
      <Route path="/app/sla-performance/:id" element={<BenchmarkDetail />} />
      <Route path="/app/benchmarks" element={<Navigate to="/app/sla-performance" replace />} />
      <Route path="/app/benchmarks/:id" element={<BenchmarkDetail />} />
      <Route path="/app/reports" element={<Reports />} />
      <Route path="/app/history" element={<HistoryRecords />} />
      <Route path="/app/history/:scope/:period/:subjectId/:recordKey" element={<HistoryReportDetail />} />
      <Route path="/app/integrations" element={<Integrations />} />
      <Route path="/app/settings" element={<Settings />} />
    </Route>

    <Route path="/welcome" element={<Navigate to="/" replace />} />
    <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </>
}
